//
// TODO: Describe the purpose of this HOC
//

// TODO: Explain why we're whitelisting these rules
/* eslint react/jsx-props-no-spreading: 0 */
/* eslint react/prop-types: 0 */

import React from 'react';
import MissingFields from '@components/MissingFields';

/* eslint import/no-dynamic-require: 0 */
const schema = require(`../../../model/model-smm-${process.env.CONTENTFUL_ENVIRONMENT}`);

const withNullChecks = (hocProps) => (BaseComponent) => (props) => {
  const { dataKey, typeName } = hocProps;
  const { data } = props;
  const templateData = data[dataKey];

  const fetchInvalidFields = () => {
    const invalidFields = [];
    const requiredFields = [];
    const contentType = schema.contentTypes.filter((type) => type.sys.id === typeName)[0];

    if (contentType) {
      contentType.fields.forEach((field) => {
        if (field.required) requiredFields.push(field.id);
      });
    }

    for (let i = 0; i < requiredFields.length; i += 1) {
      const wasQueried = Object.prototype.hasOwnProperty.call(templateData, requiredFields[i]);
      if (wasQueried && !templateData[requiredFields[i]]) {
        invalidFields.push(requiredFields[i]);
      }
    }

    return invalidFields;
  };

  const handleInvalidFieldsRedirect = () => {
    const isBrowser = typeof window !== 'undefined';

    if (isBrowser) {
      window.location.replace('https://www.smm.org/404');
    }

    return null;
  };

  const invalidFields = fetchInvalidFields(data, schema, typeName);

  if (invalidFields.length > 0 && process.env.NODE_ENV === 'production') {
    return handleInvalidFieldsRedirect();
  }

  if (invalidFields.length > 0 && process.env.NODE_ENV === 'development') {
    return (
      <MissingFields typeName={typeName} invalidFields={invalidFields} />
    );
  }

  return (
    <BaseComponent {...props} {...{ schema }} />
  );
};

export default withNullChecks;
